import * as parameterActionTypes from './parameterActionTypes';

export const setParameterList = (parameterList) => ({
  type: parameterActionTypes.SET_PARAMETER_LIST,
  parameterList,
});

export const addParameter = (parameter) => ({
  type: parameterActionTypes.ADD_PARAMETER,
  parameter,
});

export const updateParameter = (parameter) => ({
  type: parameterActionTypes.UPDATE_PARAMETER,
  parameter,
});

export const deleteParameter = (parameterId) => ({
  type: parameterActionTypes.DELETE_PARAMETER,
  parameterId,
});



// WEBPACK FOOTER //
// ./src/parameter/parameterActions.js